import React from "react";
import CompanyLogo from "../../../../assets/img/logos/dicelogoTransparent_01.png";
import CompanyLogo02 from "../../../../assets/img/logos/original.png";
import QrCodes from "../appComponents/QrCodes";
const CatTable = (props) => {
  const myStyle = {
    backgroundImage: `url(${CompanyLogo02})`,
    height: "100%",
    width: "100%",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    display: "Block",
    position: "absolute",
    zIndex: "20",
  };

  //replaces each first character of a word with its uppercase version
  function ucwords(str) {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  }
  return (
    <>
      <div className="row">
        <table width="100%" border="0" cellspacing="0" cellpadding="50">
          <tr>
            <td>
              {props.general.stamp && <div style={myStyle}></div>}
              <table
                width="100%"
                border="0"
                align="left"
                cellpadding="6"
                cellspacing="0"
              >
                <tr>
                  <td colspan="3" align="left" valign="top" bgcolor="#FFFFFF">
                    <label></label>
                    <table
                      width="100%"
                      border="0"
                      cellspacing="1"
                      cellpadding="5"
                    >
                      <tr>
                        <td width="20%" height="83">
                          <img
                            name=""
                            src={CompanyLogo}
                            width="100"
                            height="100"
                            alt=""
                          />
                        </td>
                        <td width="60%">
                          <table
                            width="100%"
                            border="0"
                            align="center"
                            cellpadding="2"
                            cellspacing="0"
                          >
                            <tr>
                              <td
                                width="100%"
                                align="center"
                                valign="top"
                                color="#FF0000"
                              >
                                <font size="4">
                                  <b>WEBDYNAMO CONTENT MANAGEMENT SYSTEM </b>
                                  <br />
                                </font>
                                FROM CVIEWSOFT
                              </td>
                            </tr>
                            <tr>
                              <td align="center" valign="top">
                                <b>CATEGORY DASHBOARD PRINTOUT</b>
                              </td>
                            </tr>
                            <tr>
                              <td height="19" align="center" valign="top">
                                {/* <b>For:</b> {props.general.salaryDate} */}
                              </td>
                            </tr>
                            <tr>
                              <td height="8" align="center" valign="top">
                                <hr />
                              </td>
                            </tr>
                          </table>
                        </td>
                        <td width="20%" align="right" valign="top">
                          <table
                            width="100%"
                            border="0"
                            cellspacing="0"
                            cellpadding="0"
                          >
                            <tr>
                              <td>
                                <table
                                  align="right"
                                  width="100%"
                                  border="0"
                                  cellspacing="0"
                                  cellpadding="1"
                                >
                                  <tr>
                                    <td
                                      width="40%"
                                      align="right"
                                      valign="middle"
                                    >
                                      <b>Slip NO.</b>
                                      {props.general.referenceNo && (
                                        <div
                                          style={{
                                            marginLeft: "0px",
                                            paddingTop: "0px",
                                            paddingRight: "60px",
                                            display: "Block",
                                            position: "absolute",
                                            zIndex: "10",
                                          }}
                                        >
                                          <QrCodes
                                            addrurl={props.general.referenceNo}
                                            qrcodeSize={"70%"}
                                          />
                                        </div>
                                      )}
                                    </td>
                                    <td width="60%" align="right" valign="top">
                                      00000000
                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>

                <tr>
                  <tr>
                    <td height="40"></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tr>

                <tr>
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        {[
                          { column: "Category's", width: "30%" },
                          { column: "Created By", width: "40%" },
                          { column: "Visibility", width: "15%" },
                          { column: "Published Date", width: "15%" },
                        ].map((items, index) => (
                          <>
                            <th
                              key={index}
                              scope="col"
                              style={{ width: items.width }}
                            >
                              {items.column}
                            </th>
                          </>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {props.itemId.map((allRecord, index) => {
                        return (
                          <tr key={index}>
                            <td>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: allRecord.webPageName,
                                }}
                              />
                            </td>
                            <td>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: allRecord.createdBy,
                                }}
                              />
                            </td>
                            <td>{ucwords(allRecord.status02)}</td>
                            <td>
                              {
                                new Date(allRecord.creationDate * 1000)
                                  .toISOString()
                                  .split("T")[0]
                              }
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </div>
    </>
  );
};

export default CatTable;
